import { useCallback, useLayoutEffect, useState } from 'react';

export interface Dimensions {
    width: number;
    height: number;
    top: number;
    left: number;
}

export const useMeasure = <T extends HTMLElement>() => {
    const [dimensions, setDimensions] = useState<Dimensions>({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
    });

    const [node, setNode] = useState<T | null>(null);

    const ref = useCallback((node: T | null) => {
        setNode(node);
    }, []);

    useLayoutEffect(() => {
        if (!node) return;

        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) {
                const { width, height, top, left } = entry.contentRect;
                setDimensions({ width, height, top, left });
            }
        });

        observer.observe(node);

        const rect = node.getBoundingClientRect();
        setDimensions({
            width: rect.width,
            height: rect.height,
            top: rect.top,
            left: rect.left,
        });

        return () => observer.disconnect();
    }, [node]);

    return [ref, dimensions, node] as const;
};
